import type { MongoAbility } from "@casl/ability";
import { createMongoAbility } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import { observer } from "mobx-react-lite";
import React, { createContext, useMemo } from "react";

import { ActionsForRole } from "@/api/admin/roleManagment/types";
import { useStore } from "@/store/StoreContext";
import type { AbilityAppSections } from "@/types/common";

export type AppAbility = MongoAbility<[ActionsForRole, AbilityAppSections]>;

export const AbilityContext = createContext<AppAbility>(createMongoAbility());
export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityProvider = observer(
  ({ children }: { children: React.ReactNode }) => {
    const store = useStore();

    const permissions = store.authStore.isAdmin
      ? store.adminAccessStore.permissions
      : store.restaurantAccessStore.currentPermissions;

    const ability = useMemo(() => {
      const rules = permissions.flatMap(p => {
        if (p.action === ActionsForRole.UPDATE) {
          return [
            { action: ActionsForRole.UPDATE, subject: p.section },
            { action: ActionsForRole.READ, subject: p.section },
          ];
        }
        return [{ action: p.action, subject: p.section }];
      });

      return createMongoAbility<AppAbility>(rules);
    }, [permissions]);

    return (
      <AbilityContext.Provider value={ability}>
        {children}
      </AbilityContext.Provider>
    );
  }
);
